import React, { Component } from 'react';
import { connect } from 'react-redux';
import Modal from '../Modal';
import ChangedPasswordForm from '../ChangedPasswordForm';
import * as modal from '../../reducers/modalReducer';

import { rootPageUri } from '../../config/uri';
import { startChangePassword } from '../../actions/signup-sync';

class ChangedPasswordFormModal extends Component {
    isClosed = false;
    
    onCloseRequest = () => {
      if (this.isClosed) return;
        this.props.hideModal();
    }

    handleSubmit = (values) => {
      this.props.changePassword(values);
    }

    render() {
      return (
        <Modal paddingTop={'65px'} overlayTop={0} closeOnOverlayClick={true} closeOnOutsideClick={false} isOpened={true} onClose={this.onCloseRequest}>
          <ChangedPasswordForm onCloseRequest={this.onCloseRequest} onSubmit={this.handleSubmit}/>
        </Modal>
      );
    }
}

const mapDispatchToProps = (dispatch) => {
  return { 
    openMainPage: () => dispatch(pushWithQueryParams(rootPageUri)),
    hideModal: () => dispatch(modal.hideModal()),
    changePassword: (values) => dispatch(startChangePassword(values))
  };
};

export default connect(null, mapDispatchToProps)(ChangedPasswordFormModal);


// WEBPACK FOOTER //
// ./src/components/ChangedPasswordFormModal/ChangedPasswordFormModal.jsx